import IconAdd from "@/assets/images/icon-add circle-filled.svg?react";
import styled from "@emotion/styled";

export const IconAddStyle = styled(IconAdd)`
  & path {
    fill: #3548c9;
  }
`;

export const ReferOutContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const ReferOutTitleContainer = styled.div`
  height: 100%;
  max-width: max-content;
  display: flex;
  gap: 12px;
  align-items: flex-start;
`;

export const Flex = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
  flex-direction: column;
  flex-grow: 1;
`;

export const ReferOutFlex = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 12px;
  & > div {
    width: 100%;
  }
  & .button-add {
    width: fit-content;
    height: 56px;
  }
  & .button-delete {
    width: fit-content;
    height: 56px;
    border: thin solid rgb(235, 69, 83) !important;
    & > svg {
      fill: rgb(235, 69, 83) !important;
    }
  }
`;

export const ReferOutTitle = styled.p`
  margin: 0px;
  font-size: 14px;
  font-weight: 700;
  line-height: 56px;
  color: #253858;
`;
